import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';

export const FirstDayEmploymentGridItem = styled(Grid).attrs(
    {
        item: true,
        container: true,
        direction: 'column',
        alignItems: 'center'
    }
)`
  && {
    margin-bottom: 10px;
    margin-top: 10px;
    margin-right: 10px;
  }
`;

export const InlineDateField = styled(MaskedInput)`
    font-size: 1rem;
    padding: 10px 7px;
    width: 100%;
    max-width: 180px
`;

export const AdditionalInformation = styled.span`
  font-weight: bold;
`;

export const BorderedBox = styled.div`
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.3);
  border-width: 2px;
  padding: 4px 7px;
`;



// WEBPACK FOOTER //
// ./src/screens/review-section2/complete-i9/styles.tsx